export default __webpack_public_path__ + "overnight-camp-data.jpg";